import {Nullish} from 'shared/web';

import {ListFeaturesItemProps} from '../components/ListFeatures/components/ListFeaturesItem';
import {isListFeatureVisible} from './isListFeatureVisible';

type PartialFeature = Omit<ListFeaturesItemProps, 'title'> & {title: string | Nullish};

export function filterListFeatures(features: PartialFeature[], showEmptyFields: boolean) {
  return features.filter((feature) => isListFeatureVisible(feature, showEmptyFields));
}
